import React, { useState } from 'react';
import { UserRound } from 'lucide-react';

import { getProfilePictureUrl } from '../utils/profilePicture';

const getInitials = (name) => {
  const parts = String(name || 'Member')
    .trim()
    .split(/\s+/)
    .filter(Boolean);

  if (!parts.length) return 'M';
  return parts.slice(0, 2).map((part) => part.charAt(0).toUpperCase()).join('');
};

export const InquiryCreatorAvatar = ({ name, profilePicture, size = 'md' }) => {
  const [imageFailed, setImageFailed] = useState(false);
  const photoUrl = getProfilePictureUrl({ profile_picture: profilePicture });
  const sizeClasses = size === 'lg'
    ? 'h-16 w-16 text-lg'
    : size === 'sm'
      ? 'h-8 w-8 text-[11px]'
      : 'h-10 w-10 text-sm';

  return (
    <div
      className={`flex shrink-0 items-center justify-center overflow-hidden rounded-full bg-blue-100 font-semibold text-blue-700 ${sizeClasses}`}
      aria-label={`${name || 'Member'} profile picture`}
    >
      {photoUrl && !imageFailed ? (
        <img
          src={photoUrl}
          alt={`${name || 'Member'} profile picture`}
          className="h-full w-full object-cover"
          onError={() => setImageFailed(true)}
        />
      ) : name ? (
        <span aria-hidden="true">{getInitials(name)}</span>
      ) : (
        <UserRound size={size === 'lg' ? 28 : 18} aria-hidden="true" />
      )}
    </div>
  );
};

const InquiryCreatorIdentity = ({
  name,
  profilePicture,
  companyName,
  label = 'Created by',
  compact = false,
  className = '',
}) => {
  const creatorName = name || 'Member';

  return (
    <div className={`flex min-w-0 items-center gap-2 ${className}`.trim()}>
      <InquiryCreatorAvatar
        name={creatorName}
        profilePicture={profilePicture}
        size={compact ? 'sm' : 'md'}
      />
      <div className="min-w-0">
        {label && <p className="text-xs text-gray-500">{label}</p>}
        <p className={`truncate font-medium text-gray-900 ${compact ? 'text-sm' : ''}`}>
          {creatorName}
        </p>
        {companyName && (
          <p className="truncate text-xs text-gray-500">{companyName}</p>
        )}
      </div>
    </div>
  );
};

export default InquiryCreatorIdentity;
